import { render, staticRenderFns } from "./DSSOtherMedication.vue?vue&type=template&id=f7e94d26&"
import script from "./DSSOtherMedication.vue?vue&type=script&lang=js&"
export * from "./DSSOtherMedication.vue?vue&type=script&lang=js&"
import style0 from "./DSSOtherMedication.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports